import NewUser from '@/modules/users/components/NewUser'

export default [
  {
    path: '/users/new',
    name: 'users/new',
    component: NewUser
  }
]



// WEBPACK FOOTER //
// ./src/modules/users/routes.js